import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

export const orderFormSchema = z.object({
  productType: z.string().min(1, "Product type is required"),
  product: z.string().min(1, "Product is required"),
  quantity: z.string().min(1, "Quantity is required"),
  startDate: z.string().min(1, "Start date is required"),
  dueDate: z.string().min(1, "Due date is required"),
  tagKey: z.string(),
  tagValue: z.string(),
  tags: z.array(
    z.object({
      key: z.string(),
      value: z.string(),
    })
  ),
  locations: z
    .array(
      z.object({
        id: z.string(),
        value: z.any(),
      })
    )
    .min(1, "At least one location is required"),
});

export type OrderFormData = z.infer<typeof orderFormSchema>;

export const useOrderForm = () => {
  return useForm<OrderFormData>({
    resolver: zodResolver(orderFormSchema),
    defaultValues: {
      productType: "",
      product: "",
      quantity: "",
      startDate: "",
      dueDate: "",
      tagKey: "",
      tagValue: "",
      tags: [],
      locations: [{ id: Date.now().toString(), value: null }],
    },
    mode: "onChange",
  });
};
